import { prop } from 'datx';
import { Resource } from 'datx-jsonapi-react';

export class LectureTags extends Resource {
  public static type = 'library/lecture_tags';

  @prop
  public name: string;
}
